// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-box {\n    margin: 15px 20px;\n    background-color: white;\n    padding: 15px 20px;\n    font-size: 16px;\n    border-radius: 5px;\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.info-box .vesta-button {\n    height: 35px;\n    font-size: 12px;\n}\n\n.info-box .title {\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.info-box .description {\n    margin-top: 7px;\n    margin-bottom: 17px;\n}", ""]);
// Exports
module.exports = exports;
